import * as request from '../api-request'
import getToken from '../get-token'

export const availableFeatures = async (data = {}) => {
  return request.toJSON('GET', 'available_features', data)
}

export const paymentMethods = async (data = {}, token) => {
  token = token || (await getToken())
  return request.toJSON('GET', 'payment_methods/list', data, token)
}

export const deletePaymentMethod = async (data = {}, token) => {
  token = token || (await getToken())
  return request.toJSON('POST', 'payment_methods/delete', data, token)
}

export const createPaymentMethod = async (data = {}, token) => {
  token = token || (await getToken())
  return request.toJSON('POST', 'payment_methods/create', data, token)
}

export const subscribe = async (data = {}) => {
  return request.toJSON('POST', 'subscription/subscribe', data)
}

export const unsubscribe = async (data = {}) => {
  return request.toJSON('POST', 'subscription/unsubscribe', data)
}

export const resubscribe = async (data = {}) => {
  return request.toJSON('POST', 'subscription/resubscribe', data)
}

export const changePlan = async (data = {}) => {
  return request.toJSON('POST', 'subscription/change_subscription', data)
}

export const payInvoice = async (data = {}) => {
  return request.toJSON('POST', 'subscription/pay_invoice', data)
}

export const directorySubscription = async ({ email }) => {
  return request.toJSON('POST', 'mailing/directory_subscription', { email })
}

export const onDemandSubscribe = async (data = {}) => {
  return request.toJSON('POST', 'subscription/on_demand', data)
}

export const createPortalSession = async (data = {}) => {
  return request.toJSON('POST', 'subscription/create_portal_session', data)
}

export const createSession = async (data = {}) => {
  return request.toJSON('POST', 'subscription/create_session', data)
}

// Whether this user can still be offered the 7-day Pro trial. Its own endpoint
// rather than a field on `available_features`: that route is keyed by uuid
// while the trial answer needs a Stripe lookup by email.
export const trialEligibility = async (data = {}) => {
  return request.toJSON('GET', 'subscription/trial_eligibility', data)
}
